import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges
} from "@angular/core";


import { FileUpload } from "../models/file-upload";
import { FileUploadService } from "../services/file-upload.service";
import { MatSnackBar } from "@angular/material";
import { ConfirmacaoDialog } from "../util/confirmacao.dialog";
import { MatDialog } from "@angular/material";

@Component({
  selector: "questionario-file-upload",
  template: `<div *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<table class="table table-bordered table-striped table-hover" *ngIf="lista && lista.length > 0"
  style="margin-bottom: 5px !important">
  <tbody>
    <tr *ngFor="let row of lista">
      <td role="button" *ngIf="row.nomeArquivo" (click)="download(row.id)"
        class="col-sm-11 col-md-11 col-lg-11 col-xl-11">{{row.nomeArquivo}}</td>
      <td class="col-sm-1 col-md-1 col-lg-1 col-xl-11 text-center" *ngIf="mostrarBotao">
        <button mat-raised-button class="button-small" title="Excluir" color="warn" (click)="excluir(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </tr>
  </tbody>
</table>
<div style="margin-bottom: 15px !important">
  <label class="custom-file-upload" *ngIf="mostrarBotao">
    <input type="file" (change)="upload($event)" accept=".pdf,.jpg,.jpeg,.png,.bmp,.gif">
    <i class="material-icons">file_upload</i> Escolher Arquivo
  </label>
</div>`,
  styles: [
    `
      input[type="file"] {
        display: none;
      }
      .custom-file-upload {
          border: 1px solid #ccc;
          display: inline-block;
          padding: 6px 12px;
          cursor: pointer;
      }
    `
  ]
})
export class FileUploadComponent {
  public isLoading: boolean;
  public fileUpload: FileUpload;
  public lista: FileUpload[];
  public mostrarBotao: boolean = true;
  @Input() desabilitado: boolean;
  @Input() mostrarSalvar: boolean;
  @Input() idPergunta: number;
  @Input() idResposta: number;
  @Input() quantidadeMaximaArquivos: number;
  @Input() listaArquivos: FileUpload[];
  @Output()
  arquivoIncluido: EventEmitter<FileUpload> = new EventEmitter<FileUpload>();
  @Output()
  arquivoExcluido: EventEmitter<FileUpload> = new EventEmitter<FileUpload>();

  // construtor
  constructor(
    public fileUploadService: FileUploadService,
    public mensagem: MatSnackBar,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.filtrarLista();
    this.mostrarBotao = this.mostrarSalvar;
    if (this.mostrarSalvar) {
      if (this.mostrarSalvar == true) {
        if (this.desabilitado) {
          this.mostrarBotao = false;
        }
      }
    }
  }
  private filtrarLista() {
    if (this.listaArquivos) {
      this.lista = this.listaArquivos.filter(
        x => x.idPergunta == this.idPergunta
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let chng = changes[propName];
      // se for a primeira vez q entrou..
      if (propName == "listaArquivos") {
        this.filtrarLista();
      }
    }
  }

  upload(event: any) {
    let fileList: any = event.target.files;
    var reader: any = new FileReader();
    reader.onload = (readerEvt: any) => {
      let arquivo: FileUpload = new FileUpload();
      arquivo.tipo = fileList[0].type;
      arquivo.nomeArquivo = fileList[0].name;
      var binaryString = readerEvt.target.result;
      arquivo.arquivo = btoa(binaryString); // Converting binary string data.
      if (this.trataArquivo(arquivo)) {
        let idPertuntaNumerico = this.idPergunta;
        this.salvarArquivo(arquivo);
      }
    };
    reader.readAsBinaryString(fileList[0]);
  }

  private trataArquivo(arquivo: FileUpload) {
    if (this.quantidadeMaximaArquivos && this.lista) {
      if (this.lista.length >= this.quantidadeMaximaArquivos) {
        this.mensagem.open(
          "Você só pode enviar " +
            this.quantidadeMaximaArquivos +
            " arquivo(s) para esta pergunta.  ",
          "X",
          { duration: 5000 }
        );
        return false;
      }
    }

    if (!arquivo.arquivo) {
      this.mensagem.open("Erro ao carregar arquivo", "X", { duration: 5000 });
      return false;
    } else {
      if (arquivo.arquivo.length > 10485760) {
        this.mensagem.open("Arquivo não pode ser maior que 10MB", "X", {
          duration: 5000
        });
        return false;
      }
    }

    return true;
  }

  private salvarArquivo(arquivo: FileUpload) {
    this.isLoading = true;
    this.mostrarBotao = false;
    if(this.idResposta){
      arquivo.idResposta = this.idResposta;
    }

    if(this.idPergunta){
      arquivo.idPergunta = this.idPergunta;
    }

    this.fileUploadService.update(arquivo).subscribe(
      (result: FileUpload) => {
        // this.mensagem.open("Upload Realizado com sucesso.", 'X', {duration: 5000});
        if (!this.lista) {
          this.lista = new Array();
        }
        
        this.lista.push(result);
        this.isLoading = false;
        this.mostrarBotao = true;
        this.arquivoIncluido.emit(result);
      },
      error => this.erro(error)
    );
  }

  public download(id: number) {
    this.isLoading = true;
    this.fileUploadService.getId(id).subscribe(
      data => {
        var byteCharacters = atob(data.arquivo);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: data.tipo });
        var url = window.URL.createObjectURL(blob);
        this.isLoading = false;
        window.open(url);
      },
      error => this.erro(error)
    );
  }

  public excluir(arquivo: FileUpload) {
    let mensagem: string = "Deseja excluir o arquivo? ";
    let dialogRef = this.dialog.open(ConfirmacaoDialog, {
      width: "400px",
      data: mensagem
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deletar(arquivo);
      }
    });
  }

  private deletar(arquivo: FileUpload) {
    this.isLoading = true;
    this.fileUploadService.deletar(arquivo).subscribe(
      result => {
        this.mensagem.open("Arquivo excluído com sucesso!", "X", {
          duration: 5000
        });
        this.arquivoExcluido.emit(arquivo);
        // recarrega a lista
        var index = this.lista.indexOf(arquivo, 0);
        if (index > -1) {
          this.lista.splice(index, 1);
        }
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, "X", { duration: 5000 });
    this.isLoading = false;
    this.mostrarBotao = true;
  }
}
